type TStubScreenProps = {
  id: string;
  heading: string;
};

/**
 * Bare placeholder body for a not-yet-built screen (DIT-671).
 * Heading only — no inputs, no validation. Each real screen sub-task
 * (Tasks 1–5) replaces its screen's content. The `amount` screen (DIT-669)
 * is the exemplar that composes StepLayout; the rest follow as they're built.
 */
export const StubScreen = ({ id, heading }: TStubScreenProps) => (
  <div data-testid={`screen-${id}`}>
    <h1>{heading}</h1>
  </div>
);
